import type { IShoppingMallTileResources } from "@/src/shopping-mall/ShoppingMallTile.Resources";

export const ShoppingMallTileResourcesEn: IShoppingMallTileResources = {
    mapLinkText: "Show location on map",
};
